import { SINGLE_API } from 'src/redux/actions/type';

export const affectCreditWithInvoice = (payload = {}, next, nextErr) => {
	return {
		type: SINGLE_API,
		payload: {
			opt: { method: 'POST' },
			params: payload,
			uri: '/affect_credit_invoice',
			beforeCallType: 'AFFECT_CREDIT_REQUEST',
			successType: 'AFFECT_CREDIT_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const checkComissionBasedOnInvoices = (payload = {}, next, nextErr) => {
	return {
		type: SINGLE_API,
		payload: {
			opt: { method: 'POST' },
			params: payload,
			uri: '/check_comission_based_on_invoices',
			beforeCallType: 'CHECK_COMISSION_REQUEST',
			successType: 'CHECK_COMISSION_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};
